import React from "react";
import { Button, Modal, CloseButton } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import closeicon from "../../../assets/images/closeicon.svg";
import DeleBlueIcon from "../../../assets/images/DeleBlueIcon.svg";
import './style.scss';

const Delete = ({
  showDel,
  DelItem,
  DelClose,
  title,
  Desc,
}) => {
  let location = useLocation();
  return (
    <>
      {location.pathname === "/teams" || location.pathname === "/teamusers" || location.pathname === "/teamslist" || location.pathname === "/wall" || location.pathname === "/wall/Reminders"
        || location.pathname === "/ColorLibrary/ColorGrid" ? (<>
          <Modal backdrop="static" show={showDel} onHide={DelClose} className={location.pathname === "/wall/Reminders" ? "deletePopup ReminderPopup" : "deletePopup"}>
            <Modal.Header>
              <span className="ModalLogo">
                <img src={DeleBlueIcon} alt="" />
              </span>
              <Modal.Title>{title}</Modal.Title>
              <closeButton className="closebutton" onClick={DelClose}>
                <img src={closeicon} alt="" />
              </closeButton>
            </Modal.Header>
            <Modal.Body>
              <p>{Desc}</p>
            </Modal.Body>
            <Modal.Footer className="">
              <Button variant="secondary" onClick={DelClose}>Cancel</Button>
              <Button variant="primary" onClick={DelItem}>Delete</Button>
            </Modal.Footer>
          </Modal>
        </>) : (<>
          <Modal backdrop="static" show={showDel} onHide={DelClose} className="AddteamPopup">
            <Modal.Header>
              <span className="ModalLogo">
                <img src={DeleBlueIcon} alt="" />
              </span>
              <Modal.Title>{title}</Modal.Title>
              <CloseButton className="closebuttonbtn" onClick={DelClose}>
                <img src={closeicon} alt="" />
              </CloseButton>
            </Modal.Header>
            {location.pathname === "/pricing" ? (
              <Modal.Footer className="justify-content-center">
                <Button variant="primary" onClick={DelItem}>
                  Yes
                </Button>
                <Button variant="secondary" onClick={DelClose}>
                  No
                </Button>
              </Modal.Footer>
            ) : (
              <Modal.Footer className="justify-content-center">
                <Button variant="secondary" onClick={DelClose}>
                  cancel
                </Button>
                <Button variant="primary" onClick={DelItem}>
                  Delete
                </Button>
              </Modal.Footer>
            )}
          </Modal>
        </>)}
      {/* <Modal show={showDel} onHide={DelClose} className="AddteamPopup">
        <Modal.Header>
          <span className="ModalLogo">
            <img src={DeleBlueIcon} />
          </span>
          <Modal.Title>{title}</Modal.Title>
          <CloseButton className="closebuttonbtn" onClick={DelClose}>
            <img src={closeicon} />
          </CloseButton>
        </Modal.Header>
        <Modal.Footer className="justify-content-center">
          <Button variant="secondary" onClick={DelClose}>
            cancel
          </Button>
          <Button variant="primary" onClick={DelItem}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal> */}
    </>
  );
};
export default Delete;
